import React from 'react';
import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    InputBase,
    Badge,
    MenuItem,
    Menu,
    Grid,
    Paper,
    Avatar,
    Box,
    Tabs,
    Tab,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PersonIcon from '@mui/icons-material/Person';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ClockIcon from '@mui/icons-material/AccessTime';
import EmailIcon from '@mui/icons-material/Email';
import ChartIcon from '@mui/icons-material/ShowChart';
import MoneyIcon from '@mui/icons-material/MonetizationOn';
import CalendarIcon from '@mui/icons-material/Event';
import SearchIcon from '@mui/icons-material/Search';
import StoreIcon from '@mui/icons-material/Store';
import SchoolIcon from '@mui/icons-material/School';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import HelpIcon from '@mui/icons-material/Help';

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#fff',
    color: 'black',
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
    },
}));

const Welcome: React.FC = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [value, setValue] = React.useState(0);

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <>
            <AppBar position="static" sx={{ bgcolor: 'gray.800' }}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        iNSPiRE
                    </Typography>
                    <Search>
                        <InputBase
                            placeholder='Ask "how much PTO do I have?"'
                            inputProps={{ 'aria-label': 'search' }}
                        />
                    </Search>
                    <IconButton color="inherit">
                        <HomeIcon />
                    </IconButton>
                    <IconButton color="inherit">
                        <Badge badgeContent={9} color="error">
                            <NotificationsIcon />
                        </Badge>
                    </IconButton>
                    <Avatar
                        alt="User profile picture"
                        src="https://storage.googleapis.com/a1aa/image/rlvFBLQD4xYqPlirvs5mxMF2vjdmDG6gFK05WUrCeSP0RozJA.jpg"
                        sx={{ ml: 2 }}
                    />
                    <IconButton
                        edge="end"
                        color="inherit"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                    >
                        <ExpandMoreIcon />
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleClose}>Profile</MenuItem>
                        <MenuItem onClick={handleClose}>Logout</MenuItem>
                    </Menu>
                </Toolbar>
            </AppBar>

            <Box p={3}>
                <Typography variant="h4" gutterBottom>
                    Good morning, Gretchen Adams!
                </Typography>

                <Tabs value={value} onChange={handleChange} textColor="inherit" indicatorColor="secondary">
                    <Tab label="Suggestions" />
                    <Tab label="Me" />
                    <Tab label="My Team" />
                    <Tab label="My Client Groups" />
                </Tabs>

                <Grid container spacing={3} mt={3}>
                    <Grid item xs={12} sm={4}>
                        <Typography variant="h6" gutterBottom>
                            QUICK ACTIONS
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemIcon>
                                    <PersonIcon />
                                </ListItemIcon>
                                <ListItemText primary="Personal Details" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <ClockIcon />
                                </ListItemIcon>
                                <ListItemText primary="Add Time Card" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <EmailIcon />
                                </ListItemIcon>
                                <ListItemText primary="Contact Information" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <ChartIcon />
                                </ListItemIcon>
                                <ListItemText primary="My Career Development" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <MoneyIcon />
                                </ListItemIcon>
                                <ListItemText primary="Payslips" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <CalendarIcon />
                                </ListItemIcon>
                                <ListItemText primary="Add Absence" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <SearchIcon />
                                </ListItemIcon>
                                <ListItemText primary="Search Jobs" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <StoreIcon />
                                </ListItemIcon>
                                <ListItemText primary="Opportunity Marketplace" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <SchoolIcon />
                                </ListItemIcon>
                                <ListItemText primary="What to Learn" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <MoreVertIcon />
                                </ListItemIcon>
                                <ListItemText primary="Show More" />
                            </ListItem>
                        </List>
                    </Grid>

                    <Grid item xs={12} sm={8}>
                        <Typography variant="h6" gutterBottom>
                            APPS
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Paper sx={{ p: 3, textAlign: 'center', bgcolor: 'teal.700', color: 'white' }}>
                                    <PersonIcon fontSize="large" />
                                    <Typography>Personal Info</Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={4}>
                                <Paper sx={{ p: 3, textAlign: 'center', bgcolor: 'teal.700', color: 'white' }}>
                                    <ChartIcon fontSize="large" />
                                    <Typography>Career and Performance</Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={4}>
                                <Paper sx={{ p: 3, textAlign: 'center', bgcolor: 'teal.700', color: 'white' }}>
                                    <HelpIcon fontSize="large" />
                                    <Typography>Benefits</Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={4}>
                                <Paper sx={{ p: 3, textAlign: 'center', bgcolor: 'teal.700', color: 'white' }}>
                                    <StoreIcon fontSize="large" />
                                    <Typography>Opportunity Marketplace</Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={4}>
                                <Paper sx={{ p: 3, textAlign: 'center', bgcolor: 'teal.700', color: 'white' }}>
                                    <AddIcon fontSize="large" />
                                    <Typography>Learning</Typography>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export { Welcome };
